import { MenuPath, HistoryType } from '../types';

export const createMenus = (fmeaEnabled: boolean) => {
    const menus = [
        {
            id: MenuPath.AIR,
            icon: 'SolidHome',
        },
        {
            id: MenuPath.TOOLS,
            icon: 'SolidLayers',
            children: [
                {
                    id: MenuPath.TECHRESEARCH,
                },
                {
                    id: MenuPath.TECKMIND,
                }
            ],
        },
        {
            id: MenuPath.NEWSLETTER,
            icon: 'SolidAim',
            children: [
                {
                    id: MenuPath.NEWSLETTER_TOPIC,
                },
                {
                    id: MenuPath.NEWSLETTER_SUBSCRIPTION,
                }
            ],
        }
    ];

    if (fmeaEnabled) {
        menus?.[1]?.children?.push({
            id: MenuPath.TECHRISK,
        });
    }

    return menus;
};

export const HISTORY_MENU_ITEM = {
    id: MenuPath.HISTORY,
    icon: 'SolidTimeRefresh',
};

export const INCOGNITO_MENU_ITEM = {
    id: MenuPath.INCOGNITO,
    icon: 'SolidSecutiry',
}

export const JUMP_PACKAGE = {
    [MenuPath.AIR]: 'air/#',
    [MenuPath.TECHRESEARCH]: 'project/#',
    [MenuPath.TECKMIND]: 'whiteboard/#',
    [MenuPath.TECHRISK]: 'fmea/#',
    [MenuPath.NEWSLETTER_TOPIC]: 'newsletter/#/topics',
    [MenuPath.NEWSLETTER_SUBSCRIPTION]: 'newsletter/#/mySubscription',
    [HistoryType.SEEK_SEARCH]: 'air/#',
    [HistoryType.TECH_MIND]: 'whiteboard/#',
    [HistoryType.IDEA_EXPLORATION]: 'whiteboard/#',
    [HistoryType.TECH_RESEARCH]: 'project/#',
    [HistoryType.TECH_FMEA]: 'fmea/#',
};

export const EVENTS_CONFIG = {
    [MenuPath.AIR]: 'SS Seek Search',
    [MenuPath.TECHRESEARCH]: 'SS Project',
    [MenuPath.TECKMIND]: 'SS Idea AI',
    [MenuPath.TECHRISK]: 'SS Tech FMEA',
    [MenuPath.NEWSLETTER_TOPIC]: 'SS News Letter',
    [MenuPath.NEWSLETTER_SUBSCRIPTION]: 'SS News Letter',
    [MenuPath.INCOGNITO]: 'SS Seek Search',
    [HistoryType.SEEK_SEARCH]: 'SS Seek Search',
    [HistoryType.TECH_MIND]: 'SS Idea AI',
    [HistoryType.TECH_FMEA]: 'SS Tech FMEA',
    [HistoryType.TECH_RESEARCH]: 'SS Project',
    [HistoryType.IDEA_EXPLORATION]: 'SS Idea AI',
};

export const getPath = (id: string, type: string) => {
    const paths = {
        [HistoryType.SEEK_SEARCH]: `/page/${id}`,
        [HistoryType.TECH_MIND]: `/chat/${id}`,
        [HistoryType.IDEA_EXPLORATION]: `/chat/${id}`,
        [HistoryType.TECH_RESEARCH]: `/chat/${id}`,
        [HistoryType.TECH_FMEA]: `/page/${id}`,

    };
    return paths[type] || '';
};

export const getHistoryTypeToMenuPath = (type: string) => {
    const paths = {
        [HistoryType.SEEK_SEARCH]: MenuPath.AIR,
        [HistoryType.TECH_MIND]: MenuPath.TECKMIND,
        [HistoryType.IDEA_EXPLORATION]: MenuPath.TECKMIND,
        [HistoryType.TECH_RESEARCH]: MenuPath.TECHRESEARCH,
        [HistoryType.TECH_FMEA]: MenuPath.TECHRISK,
    };
    return paths[type];
}

export const SAVED_COLLAPSE_KEY = 'COMMON_NAV_COLLAPSE';

export const ROUTE_NAME_WHITELIST = ['chatDetail'];

export const getNewsletterSourceToMenuPath = (source = '') => {
    const paths = {
        my: MenuPath.NEWSLETTER_SUBSCRIPTION,
        list: MenuPath.NEWSLETTER_TOPIC,
    };
    return paths[source];
}
